<template>
<div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">

            <!--Portada General-->

            <!--INICIO SLIDE-1--> 
            <div class="swiper-slide swiper-no-swiping" data-title="Elementos de contextualización / pág. 1">
                <div class="container d-flex justify-content-center h-100">
                    <div class="row align-self-center justify-content-center">                     
                        
                        <div class="col-lg-4 col-md-12 col-sm-12 col-12 d-flex justify-content-center">
                            <div>
                                <h3 class="text-center mb-4 color7Ppal">Creado por:</h3>
                                <a href="https://www.itm.edu.co/" target="_blank"><img src="recursos/img/logo-itm-azul.png" class="img-fluid d-flex mx-auto mb-5 mb-lg-0" alt=""></a>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-12 col-sm-12 col-12 offset-lg-2 d-flex justify-content-center mt-lg-5 bordelogoini ml-0 pl-0">
                            <a href="https://www.medellin.gov.co/" target="_blank"><img src="recursos/img/logo-alcaldia.png" class="img-fluid d-flex mx-auto pl-4" alt="">         </a>                  
                                    
                        </div>
                        <div class="row mt-5">
                            <div class="col-12">
                                <div class="mt-5">
                                    <img src="recursos/img/Linea-portada.png" class="img-fluid" alt="">
                                    <h3 class="mt-2 text-center pportada">www.itm.edu.co</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--INICIO SLIDE-1-->

            <!--INICIO SLIDE-2-->
            <div class="swiper-slide swiper-no-swiping portada" data-title="pág. 2">
                <div class="p-conten">
                    <img src="recursos/img/FM_U2_T1.png" alt="" class="d-none d-md-block d-sm-none">
                    <!--<img src="recursos/img/FM_U1_T1_slide3.png" alt="" class="d-block d-md-none">-->
                    <div class="row justify-content-center">
                        <div class="col-xl-6 col-lg-8 col-md-12">
                            <h1 class="color1Ppal">Unidad 1: Razonamiento analógico</h1>
                            <hr class="lineaPortada">
                            <h2 class="color1Ppal">Fundamentos de Matemáticas</h2>
                            <h3 class="color1Ppal">Facultad de Artes y Humanidades</h3>
                        </div>
                    </div>
                    <h6 class="color1Ppal p-2 d-md-block d-none">Foto por <a href="https://www.pexels.com/es-es/@divinetechygirl" target="_blank" class="portadaEnlace">Christina Morillo</a> en <a href="https://www.pexels.com/es-es/foto/mujer-vistiendo-chaqueta-gris-escrito-en-pizarra-de-borrado-en-seco-1181534/" target="_blank" class="portadaEnlace">Pexels</a></h6>
                </div>
            </div>

            <!--INICIO SLIDE-3-->
            <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="pág. 3">
                <div class="container">
                    <div class="row mt-4">
                        <div class="col-12">
                            <h2 class="mt-5">Elementos de contextualización</h2>
                            <h3 class="my-4">Introducción</h3>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-7 col-12">
                            <p>En esta unidad se abordarán los contenidos matemáticos con los que se desarrollarán las habilidades propias del tercer tipo de razonamiento: <i>el razonamiento analógico</i>. Este razonamiento permite encontrar similitudes o relaciones entre cantidades, términos u objetos, y traslada los rasgos comunes que se conocen de ellos o de sus partes a otros no conocidos, utilizando las herramientas que proporcionan las matemáticas para tal fin.</p>
                        </div>
                        <div class="col-lg-5 col-12">
                            <p>Así mismo, se comienza la unidad con la presentación de algunos ejemplos de analogías entre figuras. Luego, se hace un trabajo más formal y se abordan los conceptos de <i>razón</i> y <i>proporción</i> y sus relaciones y propiedades; estos se aplican a problemas de la <i>regla de tres</i> y del <i>tanto por ciento</i>. Igualmente, se muestra la importancia de dichos conceptos en los procesos que llevan a la resolución de ecuaciones matemáticas y se muestran algunos métodos de ayuda para la interpretación y resolución de problemas con el uso de dichas ecuaciones.</p>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row Fondo3Ppal justify-content-center">
                        <div class="col-lg-6 col-12">
                            <div class="p-3">
                                <h4 class="text-white font-weight-bold mb-3">Competencia </h4>
                                <p class="mb-0 pb-0 text-white">Desarrollar habilidades de razonamiento lógico utilizando las herramientas que proporcionan las matemáticas, para estimular el pensamiento formal, de manera que se posibilite la resolución de problemas en los distintos ámbitos del conocimiento.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-xl-7">
                            <h3 class="my-4">Indicadores de competencia</h3>
                        </div>
                    </div>
                    <div class="row mb-5">
                        <div class="col-xl-6 col-12">
                            <div class="accordion" role="tablist">
                                <b-card no-body class="mb-0">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button block v-b-toggle.accordion-1 class="btnColapsable">Establece</b-button>
                                    </b-card-header>
                                    <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <p class="mb-0 pb-0">Establece semejanzas entre objetos, relaciones u operaciones.</p>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-0">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button block v-b-toggle.accordion-2 class="btnColapsable">Reconoce</b-button>
                                    </b-card-header>
                                    <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <p class="mb-0 pb-0">Reconoce la diferencia entre magnitudes directas e inversas.</p>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-0">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button block v-b-toggle.accordion-3 class="btnColapsable">Resuelve</b-button>
                                    </b-card-header>
                                    <b-collapse id="accordion-3" visible accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <ul>
                                            <li>
                                                <p class="mb-0 pb-0">Resuelve situaciones problema haciendo uso de los conceptos de <i>razón</i> y <i>proporción</i> y de sus propiedades.</p>
                                            </li>
                                            <li>
                                                <p class="mb-0 pb-0">Resuelve ecuaciones lineales utilizando los axiomas de la igualdad.</p>
                                            </li>
                                        </ul>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-0">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button block v-b-toggle.accordion-4 class="btnColapsable">Interpreta</b-button>
                                    </b-card-header>
                                    <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <p class="mb-0 pb-0">Interpreta enunciados referidos a situaciones problema en distintos contextos.</p>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-0">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button block v-b-toggle.accordion-5 class="btnColapsable">Planea</b-button>
                                    </b-card-header>
                                    <b-collapse id="accordion-5" visible accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <p class="mb-0 pb-0">Plantea sistemas de ecuaciones a partir del enunciado de una situación problema dada.</p>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>

                                <b-card no-body class="mb-0">
                                    <b-card-header header-tag="header" class="p-0" role="tab">
                                        <b-button block v-b-toggle.accordion-6 class="btnColapsable">Determina</b-button>
                                    </b-card-header>
                                    <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                        <p class="mb-0 pb-0">Determina las operaciones que debe utilizar para resolver un problema en un contexto determinado.</p>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>                                
                            </div>
                        </div>
                        <div class="col-xl-6 col-12">
                            <div class="row d-flex justify-content-center mb-4">
                                <div class="col-md-5 col-xs-12 d-flex align-items-center justify-content-center">
                                    <img src="recursos/img/GAVI/Aprendamos_Haciendo.png" class="img-fluid" alt="">
                                </div>
                                <div class="col-md-5 col-xs-12 Lineaizq1 mt-lg-0 mt-4">
                                    <div class="pl-2">
                                        <p>
                                            <span class="font-weight-bold">Tiempo de estudio recomendado</span> <br>
                                            Semanas 12, 13 y 14.
                                        </p>
                                        <p> <span class="font-weight-bold">Área de conocimiento</span> 
                                            <br> Ciencias básicas
                                        </p>
                                        <p class="mb-0 pb-0">
                                            <span class="font-weight-bold">Programa</span><br>
                                            Interpretación y Traducción Lengua de Señas Colombiana - Español
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <b-button v-b-modal.modal-redConceptos class="d-flex mx-auto mt-5 BtnPrincipal mb-4">Red de conceptos</b-button>
                        </div>
                        <ModalRed/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {SwiperController} from '../assets/RecursosITM/js/Swiper'
import {Controles} from '../assets/RecursosITM/js/Controles'

import ModalRed from '@/components/Modales'

export default {
  name: 'Home',


  components: {
    ModalRed
  },

  mounted() {
        SwiperController(),
        document.title = this.$route.meta.title,
        Controles()
  }
}
</script>